/**
 * @generated SignedSource<<68e70f2022aac15bc2d4a8208a6e876d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConfiguratorUrlInput = {
  customToken?: string | null;
  modelID?: number | null;
  productID?: string | null;
};
export type ShoppingPreview_shoppingPreviewUrl_Query$variables = {
  input: ConfiguratorUrlInput;
};
export type ShoppingPreview_shoppingPreviewUrl_Query$data = {
  readonly shoppingPreviewUrl: string | null;
  readonly subscription: {
    readonly isOverMaxNumTestOrders: boolean;
  } | null;
};
export type ShoppingPreview_shoppingPreviewUrl_Query = {
  response: ShoppingPreview_shoppingPreviewUrl_Query$data;
  variables: ShoppingPreview_shoppingPreviewUrl_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ],
  "kind": "ScalarField",
  "name": "shoppingPreviewUrl",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOverMaxNumTestOrders",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShoppingPreview_shoppingPreviewUrl_Query",
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ShoppingPreview_shoppingPreviewUrl_Query",
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3d854071f05dae1222ae8e844fb6931b",
    "id": null,
    "metadata": {},
    "name": "ShoppingPreview_shoppingPreviewUrl_Query",
    "operationKind": "query",
    "text": "query ShoppingPreview_shoppingPreviewUrl_Query(\n  $input: ConfiguratorUrlInput!\n) {\n  shoppingPreviewUrl(input: $input)\n  subscription {\n    isOverMaxNumTestOrders\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a52121424f795440f0269f86e65e4f8c";

export default node;
